<ion-header>
  <ion-toolbar>
    <ion-title>Resumen de la factura subida</ion-title>
    <ion-buttons slot="end">
      <ion-button (click)="close()">
        <ion-icon name="close-outline"></ion-icon>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>

<ion-content>

  <div class="success-container">

    <div class="success-icon">
      <ion-icon name="document-outline"></ion-icon>
    </div>

    <h1>¡Factura recibida!</h1>

    <p class="success-message">
      Estamos validando tu factura. Te avisaremos cuando el proceso haya finalizado.
    </p>

    <div class="document-info">

      <div class="document-row">
        <span>Documento</span>
        <strong>{{ documentType }} {{ documentNumber }}</strong>
      </div>

      <div class="document-row">
        <span>Estado</span>
        <strong class="validation-status">
          {{ modifiedBill ? 'En validación' : 'Aprobada' }}
        </strong>
      </div>

    </div>

    <!-- contests -->
    <p class="title-contents">
      La factura ha sido almacenada exitosamente en estos concursos:
    </p>

    <ion-row class="ion-text-center">
      <ion-col *ngFor="let contest of contests" size="12" sizeMd="6">

        <ion-card class="ion-activatable contest-card">
          <ion-img
            class="contest-img"
            [src]="contest.image">
          </ion-img>
        </ion-card>

        <h2 class="name">{{ contest.name }}</h2>

      </ion-col>
    </ion-row>

    <!-- update data banner -->
    <div
      class="contest-banners"
      *ngIf="bannerData?.banners?.length">

      <app-advertising
        [banner]="bannerData"
        [contestStores]="[]"
        (goToUpdateData)="goUpdateData()"
        (goToBack)="submit()">
      </app-advertising>

    </div>

    <!-- just for digital contests -->
    <div class="digital-ticket-info" *ngIf="digitalContests.length > 0">

      <ion-icon name="location-outline"></ion-icon>

      <div class="digital-ticket-info-text">

        <ng-container *ngFor="let contest of digitalContests">

          <!-- digital pending approv -->
          <span *ngIf="contest.is_digital && modifiedBill === false">
            <strong>¡Tu factura fue aprobada!</strong>
            Recibirás los tickets o boletos de
            <strong>{{ contest.name }}</strong>
            en tu correo electrónico registrado.
            ¡Revisa también la carpeta de correo no deseado!
          </span>

          <!-- digital approv -->
          <span *ngIf="contest.is_digital && modifiedBill === true">
            <strong>¡Recibimos tu factura!</strong>
            Una vez el centro comercial la apruebe, recibirás los tickets
            o boletos de
            <strong>{{ contest.name }}</strong>
            en tu correo electrónico registrado.
          </span>

          <!-- original message -->
          <span *ngIf="!contest.is_digital">
            Para reclamar los bonos o tickets que ganes en
            <strong>{{ contest.name }}</strong>,
            acércate a un punto de información del centro comercial.
          </span>

        </ng-container>

      </div>

    </div>

    <!-- button -->
    <div class="action-buttons">

      <ion-button
        expand="block"
        class="register-button"
        (click)="submit()">

        <ion-icon
          slot="start"
          name="sync-outline">
        </ion-icon>

        Registrar otra factura

      </ion-button>

    </div>

  </div>

</ion-content>

<!-- <ion-footer>
  <ion-toolbar>
    <ion-buttons slot="end">
      <ion-button (click)="submit()"> Ingresar otra factura </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-footer> -->
